import React, { useEffect, useRef } from 'react';
import './aiImprove.css';

/**
 * Live streaming text surface for Improve-with-AI responses.
 */
export default function AIStreamingResponse({
  text = '',
  streaming = false,
  loading = false,
  label = 'AI Version',
}) {
  const endRef = useRef(null);

  useEffect(() => {
    if (streaming) endRef.current?.scrollIntoView({ block: 'nearest' });
  }, [text, streaming]);

  return (
    <div className={`aii-stream${streaming ? ' is-streaming' : ''}`}>
      <div className="aii-stream-label">
        {label}
        {streaming && <span className="aii-stream-pulse" aria-hidden="true" />}
      </div>
      <div className="aii-stream-body" aria-live="polite">
        {loading && !text ? (
          <div className="aii-stream-skeleton">
            <span /><span /><span />
          </div>
        ) : (
          <>
            {text || <span className="aii-stream-placeholder">Waiting for AI…</span>}
            <span ref={endRef} />
          </>
        )}
      </div>
    </div>
  );
}
